import {Action} from '@reduxjs/toolkit'
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import {put, takeLatest} from 'redux-saga/effects'
import {UserModel} from '../models/UserModel'
import {getUserByToken} from './AuthCRUD'
import {UserCvModel} from '../../profile/models/UserCv'
import {GetUserCV} from '../../profile/components/Profile'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  Login: '[Login] Action',
  Logout: '[Logout] Action',
  Register: '[Register] Action',
  UserRequested: '[Request User] Action',
  UserLoaded: '[Load User] Auth API',
  CvLoaded: '[Load Cv] Action',
  SetUser: '[Set User] Action',
}

const initialAuthState: IAuthState = {
  user: undefined,
  accessToken: undefined,
}

export interface IAuthState {
  user?: UserModel
  cv?: UserCvModel
  accessToken?: string
  sessionToken?: string
}


export const reducer = persistReducer(
  {storage, key: 'edhec-search-auth', whitelist: ['user', 'accessToken', 'sessionToken']},
  (state: IAuthState = initialAuthState, action: ActionWithPayload<IAuthState>) => {
    switch (action.type) {
      case actionTypes.Login: {
	      
        const accessToken = action.payload?.accessToken
        const sessionToken = action.payload?.sessionToken
        const user = action.payload?.user
         
        return {sessionToken, accessToken, user}
      }

      case actionTypes.Register: {
        const accessToken = action.payload?.accessToken
        return {accessToken, user: undefined}
      }

      case actionTypes.Logout: {
	    return initialAuthState
      }

      case actionTypes.UserRequested: {

        return {...state, user: undefined}
      }

      case actionTypes.UserLoaded: {
        const user = action.payload?.user
        return {...state, user}
      }

      case actionTypes.CvLoaded: {
        const cv = action.payload?.cv
        return {...state, cv}
      }

      case actionTypes.SetUser: {
        const user = action.payload?.user
        return {...state, user}
      }

      default:
        return state
    }
  }
)

export const actions = {
  login: (accessToken: string, sessionToken: string, user: any) => ({
    type: actionTypes.Login,
    payload: {accessToken, sessionToken, user}
  }),
  session_token: (sessionToken: string) => ({
    type: actionTypes.Login,
    payload: {sessionToken}
  }),
  register: (accessToken: string) => ({
    type: actionTypes.Register,
    payload: {accessToken},
  }),
  logout: () => ({type: actionTypes.Logout}),
  requestUser: () => ({
    type: actionTypes.UserRequested,
  }),
  fulfillUser: (user: UserModel) => ({type: actionTypes.UserLoaded, payload: {user}}),
  fulfillCv: (cv: UserCvModel) => ({type: actionTypes.CvLoaded, payload: {cv}}),
  setUser: (user: UserModel) => ({type: actionTypes.SetUser, payload: {user}}),
}

export function* saga() {
  yield takeLatest(actionTypes.Login, function* loginSaga() {
    yield put(actions.requestUser())
  })

  yield takeLatest(actionTypes.Register, function* registerSaga() {
    yield put(actions.requestUser())
  })

  yield takeLatest(actionTypes.UserRequested, function* userRequested() {
    const {data: user} = yield getUserByToken()
    const {data: cv} = yield GetUserCV()
    yield put(actions.fulfillCv(cv))
    yield put(actions.fulfillUser(user))
  })
}
